import { render, staticRenderFns } from "./YandexMapWrapper.vue?vue&type=template&id=565dfa73&scoped=true&"
import script from "./YandexMapWrapper.vue?vue&type=script&lang=ts&"
export * from "./YandexMapWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./YandexMapWrapper.vue?vue&type=style&index=0&id=565dfa73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565dfa73",
  null
  
)

export default component.exports